import { t } from "i18next";
import React from "react";
import ReactDOM from "react-dom";
import OutsideClickHandler from "react-outside-click-handler";
import { useNavigate } from "react-router-dom";
const Vip = () => {
  const navigate = useNavigate();
  return ReactDOM.createPortal(
    <app-popup-page
      _ngcontent-serverapp-c4268204220
      className="ng-tns-c4268204220-0 popup-page-wrapper active"
      _nghost-serverapp-c2790459173
    >
      <div
        _ngcontent-serverapp-c2790459173
        className="popup-page popup-page--active popup-page--align-top"
      >
        <div
          _ngcontent-serverapp-c2790459173
          className="popup-page__backdrop"
        />  <OutsideClickHandler onOutsideClick={() => navigate(-1)}>
        
        <div
          _ngcontent-serverapp-c2790459173
          className="popup-page__main popup-page-main popup-page-main--show"
        >
          <div
            _ngcontent-serverapp-c2790459173
            className="popup-page-main__header"
          >
            <div
              _ngcontent-serverapp-c2790459173
              className="popup-page-main__title"
            >
              {t("MyVIP")}
            </div>
            <div
              onClick={() => navigate("/")}
              _ngcontent-serverapp-c2790459173
              className="popup-page-main__close ng-star-inserted"
            />
          </div>
          <div
            _ngcontent-serverapp-c2790459173
            className="popup-page-main__container"
          >
            <div
              _ngcontent-serverapp-c2790459173
              className="content player-content vip-content"
            >
              <ng-component className="ng-tns-c161594889-30 ng-star-inserted">
                <div className="ng-tns-c161594889-30 ng-trigger ng-trigger-staggerFadeAnimation ng-star-inserted">
                  <div className="ng-tns-c161594889-30 deco lv1 player-vip-box vip-card">
                    <div className="card-top ng-tns-c161594889-30">
                      <div className="vip-lv-area ng-tns-c161594889-30">
                        <img
                          className="lv-totem ng-tns-c161594889-30"
                          alt="lv-1"
                          src="/assets/Vip/lv-1.png"
                          loading="lazy"
                        />
                        <div className="lv-text ng-tns-c161594889-30">
                          <div className="text ng-tns-c161594889-30">
                            {t("VIPLEVEL")}
                          </div>
                          <h2 className="ng-tns-c161594889-30">Normal</h2>
                        </div>
                        <div className="lv-history ng-tns-c161594889-30">
                          <span
                            className="ng-tns-c161594889-30"
                            style={{
                              "mask-image":
                                'url("/assets/Vip/icon-history.svg")',
                            }}
                          />
                          <a
                            className="ng-tns-c161594889-30"
                            href="/in/en/member/vip-history(popup:member/vip-points-exchange)"
                          />
                        </div>
                      </div>
                      <div className="vip-lv-area ng-tns-c161594889-30 ng-star-inserted">
                        <div className="progress-bar ng-tns-c161594889-30">
                          <div className="bar ng-tns-c161594889-30">
                            <div
                              className="bar-inner ng-tns-c161594889-30"
                              style={{ width: "0%" }}
                            />
                          </div>
                          <div className="number ng-tns-c161594889-30">
                            <span className="ng-tns-c161594889-30" />
                            <span className="ng-tns-c161594889-30" />
                          </div>
                        </div>
                        <img
                          className="next-lv-totem ng-tns-c161594889-30 ng-star-inserted"
                          alt="lv-2"
                          src="/assets/Vip/lv-2.png"
                          loading="lazy"
                        />
                      </div>
                      <p className="ng-tns-c161594889-30 ng-star-inserted">
                        You need 165000.0 VIP Experience to proceed to the Elite
                        I level.
                      </p>
                    </div>
                    <div
                      className="card-bottom ng-tns-c161594889-30 ng-star-inserted"
                      style={{}}
                    >
                      <a
                        className="ng-tns-c161594889-30"
                        href="/in/en/vip-detail(popup:member/vip-points-exchange)"
                      >
                        {t("ViewVIPDetails")}
                        <span
                          className="ng-tns-c161594889-30"
                          style={{
                            "mask-image": 'url("/assets/Vip/icon-arrow.svg")',
                          }}
                        />
                      </a>
                    </div>
                  </div>
                  <div className="item-ani player-vip-box total ng-tns-c161594889-30">
                    <div className="title ng-tns-c161594889-30">
                      {t("VIPPoints")}
                    </div>
                    <div className="status-box ng-tns-c161594889-30">
                      <div className="status ng-tns-c161594889-30">
                        <div className="number ng-tns-c161594889-30">0</div>
                        <div className="text ng-tns-c161594889-30">VP</div>
                      </div>
                      <div className="cleader ng-tns-c161594889-30">
                        <span
                          className="ng-tns-c161594889-30"
                          style={{
                            "mask-image": 'url("/assets/Vip/icon-points.svg")',
                          }}
                        />
                        <a
                          className="vip-cleader ng-tns-c161594889-30"
                          href="/in/en/member/vip-points-records(popup:member/vip-points-exchange)"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="item-ani player-vip-box cash-card ng-tns-c161594889-30">
                    <div className="title ng-tns-c161594889-30">
                      <h2 className="ng-tns-c161594889-30">
                        <span className="ng-tns-c161594889-30">
                          {t("ConvertVP")}
                        </span>
                      </h2>
                    </div>
                    <div
                      className="cash-points ng-tns-c161594889-30 ng-trigger ng-trigger-fadeInOut ng-star-inserted"
                      style={{}}
                    >
                      <div className="coin ng-tns-c161594889-30">
                        <div className="movie-box ng-tns-c161594889-30">
                          <video
                            drccdnvideo
                            width="100%"
                            height="100%"
                            autoPlay
                            playsInline
                            loop
                            drccdnsrc="/assets/images/vip/coin-rotate-silver.png"
                            className="ng-tns-c161594889-30 ng-star-inserted"
                            poster="/assets/Vip/coin-rotate-silver.png"
                          >
                            <source
                              drccdnsrc="/assets/images/vip/coin-rotate-silver-alpha.mov"
                              type="video/quicktime"
                              className="ng-tns-c161594889-30"
                              src="/assets/Vip/coin-rotate-silver-alpha.mov"
                            />
                            <source
                              drccdnsrc="/assets/images/vip/coin-rotate-silver-alpha.webm"
                              type="video/webm"
                              className="ng-tns-c161594889-30"
                              src="/assets/Vip/coin-rotate-silver-alpha.webm"
                            />
                          </video>
                        </div>
                        <div className="convert-icon ng-tns-c161594889-30">
                          <div className="chevron ng-tns-c161594889-30" />
                          <div className="chevron ng-tns-c161594889-30" />
                        </div>
                        <div className="movie-box ng-tns-c161594889-30">
                          <video
                            drccdnvideo
                            width="100%"
                            height="100%"
                            autoPlay
                            playsInline
                            loop
                            className="ng-tns-c161594889-30 ng-star-inserted"
                            poster="/assets/Vip/coin-rotate-gold.png"
                            style={{}}
                          >
                            <source
                              type="video/quicktime"
                              className="ng-tns-c161594889-30"
                              drccdnsrc="/assets/images/vip/coin-rotate-gold-alpha.mov"
                              src="/assets/Vip/coin-rotate-gold-alpha.mov"
                            />
                            <source
                              type="video/webm"
                              className="ng-tns-c161594889-30"
                              drccdnsrc="/assets/images/vip/coin-rotate-gold-alpha.webm"
                              src="/assets/Vip/coin-rotate-gold-alpha.webm"
                            />
                          </video>
                        </div>
                      </div>
                      <div className="cash-detail ng-tns-c161594889-30">
                        <div className="ng-tns-c161594889-30 cash-input">
                          <div className="detail-title ng-tns-c161594889-30">
                            <span className="ng-tns-c161594889-30">Points</span>
                            <p className="text ng-tns-c161594889-30">
                              {" "}
                              {t("MinimumVPRequired")} :
                              <span className="detail-title-require-points ng-tns-c161594889-30">
                                {" "}
                                10000{" "}
                              </span>
                            </p>
                          </div>
                          <input
                            type="number"
                            inputMode="numeric"
                            placeholder={0}
                            className="ng-tns-c161594889-30 ng-untouched ng-pristine ng-valid"
                          />
                        </div>
                        <div className="conversion ng-tns-c161594889-30">
                          <div className="ng-tns-c161594889-30 ratio">
                            <span className="ng-tns-c161594889-30">
                              {t("VPConversionRatio")} :{" "}
                            </span>
                            <div className="text ng-tns-c161594889-30">
                              4000
                            </div>
                          </div>
                        </div>
                        <div className="ng-tns-c161594889-30 cash-input">
                          <div className="detail-title ng-tns-c161594889-30">
                            <span
                              className="ng-tns-c161594889-30 ng-star-inserted"
                              style={{}}
                            >
                              {t("RealMoney")}
                            </span>
                          </div>
                          <input
                            type="number"
                            inputMode="numeric"
                            placeholder={0}
                            className="ng-tns-c161594889-30 ng-untouched ng-pristine ng-valid"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="item-ani button-ani ng-tns-c161594889-30 button default">
                    {t("ConverttoRealMoney")}
                    <img
                      className="ng-tns-c161594889-30 ng-star-inserted"
                      alt="convert-button-dfbg"
                      src="/assets/Vip/convert-button-dfbg.png"
                      loading="lazy"
                      style={{}}
                    />
                  </div>
                </div>
                <div
                  id="convert-content"
                  className="convert-content ng-tns-c161594889-30 ng-star-inserted"
                >
                  <div className="convert-ani ng-tns-c161594889-30 ng-trigger ng-trigger-fadeInOut ng-star-inserted">
                    <div className="coin-block ng-tns-c161594889-30">
                      <video
                        drccdnvideo
                        width="100%"
                        height="100%"
                        playsInline
                        loop
                        className="ng-tns-c161594889-30"
                        poster="/assets/Vip/vip-coin.png"
                      >
                        <source
                          type="video/quicktime"
                          className="ng-tns-c161594889-30"
                          drccdnsrc="/assets/images/vip/vip-coin-alpha.mov"
                          src="/assets/Vip/vip-coin-alpha.mov"
                        />
                        <source
                          type="video/webm"
                          className="ng-tns-c161594889-30"
                          drccdnsrc="/assets/images/vip/vip-coin-alpha.webm"
                          src="/assets/Vip/vip-coin-alpha.webm"
                        />
                      </video>
                      <div className="text ng-tns-c161594889-30">
                        {t("Success")} !
                      </div>
                    </div>
                  </div>
                </div>
              </ng-component>
            </div>
          </div>
        </div>
        </OutsideClickHandler>
      </div>
    </app-popup-page>,
    document.getElementById("overlay")
  );
};

export default Vip;
